import { render, staticRenderFns } from "./book-a-call.vue?vue&type=template&id=15a70136&scoped=true"
import script from "./book-a-call.vue?vue&type=script&lang=js"
export * from "./book-a-call.vue?vue&type=script&lang=js"
import style0 from "./book-a-call.vue?vue&type=style&index=0&id=15a70136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a70136",
  null
  
)

export default component.exports